import PropTypes from 'prop-types'; 

// material-ui
import {
  Box,
} from '@mui/material';

// project import
import MainCard from 'ui-component/cards/MainCard';

// ==============================|| AUTHENTICATION CARD WRAPPER ||============================== //


const CustomCardWrapper = ({ header, subHeader, icon, action, children, ...other }) => {

  return (
    <MainCard
      title={header} 
      subheader={subHeader}
      icon={icon}
      action={action}
      sx={{
        maxWidth: { xs: 576, lg: 992 },
        margin: { xs: 2.5, md: 3 },
        '& > *': {
          flexGrow: 1,
          flexBasis: '50%'
        }
      }}
      content={false}
      {...other}
    >
      <Box sx={{ p: { xs: 2, sm: 3, xl: 5 } }}>{children}</Box>
    </MainCard>
  );
}

CustomCardWrapper.propTypes = {
  children: PropTypes.node
};

export default CustomCardWrapper;
